<template>
  <main>
    <b-row class="match-height">
      <b-col
        xl="6"
        lg="6"
        md="12"
      >
        <dashboard-first-registry-chart :data="firstProductRegistrySeries" />
      </b-col>
      <b-col
        xl="6"
        lg="6"
        md="12"
      >
        <dashboard-statistics :data="statisticsItems" />
      </b-col>
    </b-row>
    <dashboard-product-registries />
  </main>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { BRow, BCol } from 'bootstrap-vue'
import DashboardFirstRegistryChart from './DashboardFirstRegistryChart.vue'
import DashboardStatistics from './DashboardStatistics.vue'
import DashboardProductRegistries from './DashboardProductRegistries.vue'

export default {

  components: {
    BRow,
    BCol,
    DashboardFirstRegistryChart,
    DashboardStatistics,
    DashboardProductRegistries,
  },
  computed: {
    ...mapState('dashboard', ['firstProductRegistry', 'sharedGiftPercentage', 'paidProductRegistry', 'productRegistryPrice', 'productRegistryCategory']),
    firstProductRegistrySeries() {
      return [{
        data: this.firstProductRegistry.statistic,
      }]
    },
    statisticsItems() {
      return [
        {
          icon: 'Share2Icon',
          color: 'light-primary',
          title: `${this.sharedGiftPercentage.percentage}%`,
          subtitle: 'Dibagikan',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'ShoppingCartIcon',
          color: 'light-info',
          title: `${Math.round(this.paidProductRegistry.percentage * 10) / 10}%`,
          subtitle: 'Produk Terbeli',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'DollarSignIcon',
          color: 'light-success',
          title: this.toCurrencyAbbr(this.productRegistryPrice.average),
          subtitle: 'Rata-rata Harga',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'ChevronDownIcon',
          color: 'light-warning',
          title: `${Math.round(this.productRegistryCategory.cheap * 10) / 10}%`,
          subtitle: 'Produk Murah',
          customClass: '',
        },
        {
          icon: 'ChevronUpIcon',
          color: 'light-danger',
          title: `${Math.round(this.productRegistryCategory.expensive * 10) / 10}%`,
          subtitle: 'Produk Mahal',
          customClass: 'mb-2 mb-sm-0',
        },

      ]
    },
  },
  async created() {
    await this.getFirstProductRegistry()
    await this.getProductPaidRegistry()
    await this.getProductRegistryPrice()
    await this.getProductRegistryCategory()
    await this.getSharedGiftPercentage()
  },
  methods: {
    ...mapActions('dashboard', [
      'getFirstProductRegistry',
      'getProductPaidRegistry',
      'getProductRegistryPrice',
      'getProductRegistryCategory',
      'getSharedGiftPercentage',
    ]),
    ...mapActions('products', [
      'getProductRegistries',
    ]),
    ...mapActions('registry', [
      'getProductExternal',
    ]),
  },
}
</script>
